<template>
  <PublicView>
    <main class="main" v-if="blog">
      <div class="blog-single-area pt-120 pb-120">
        <div class="container">
          <div class="row">
            <div class="col-lg-8">
              <div class="blog-single-wrapper">
                <div class="blog-single-content">
                  <!-- <div class="blog-thumb-img">
                    <img :src="blog.avatar" alt="thumb" />
                  </div> -->
                  <div class="blog-info">
                    <div class="blog-meta" v-if="false">
                      <div class="blog-meta-left">
                        <ul>
                          <li>
                            <i class="far fa-user"></i><a href="#">Jean R Gunter</a>
                          </li>
                          <li><i class="far fa-comments"></i>3.2k Comments</li>
                          <li><i class="far fa-thumbs-up"></i>1.4k Like</li>
                        </ul>
                      </div>
                      <div class="blog-meta-right">
                        <a href="#" class="share-btn"><i class="far fa-share-alt"></i>Share</a>
                      </div>
                    </div>
                    <div class="blog-details">
                      <h3 class="blog-details-title mb-20">
                        {{ blog.name }}
                      </h3>
                      <div class="article-content" v-html="blog.description"></div>
                    </div>
                    <hr class="mr-20" />
                    <div class="blog-details-tags pb-20">
                      <h5 style="width: 80px">Tags :</h5>
                      <ul style="
                          display: flex;
                          flex-wrap: wrap;
                          width: calc(100% - 80px);
                        ">
                        <li v-for="ta in blogTag" :key="ta">
                          <a href="#">{{ ta }}</a>
                        </li>
                      </ul>
                    </div>
                    <div id="blog-comments" class="fb-comments" :data-href="currentHref" data-width="100%"
                      data-numposts="10"></div>
                    <!-- <div class="blog-author">
                      <div class="blog-author-img">
                        <img src="assets/img/blog/author.jpg" alt="" />
                      </div>
                      <div class="author-info">
                        <h6>Author</h6>
                        <h3 class="author-name">Roger D Duque</h3>
                        <p>
                          It is a long established fact that a reader will be
                          distracted by the abcd readable content of a page when
                          looking at its layout that more less.
                        </p>
                        <div class="author-social">
                          <a href="#"><i class="fab fa-facebook-f"></i></a>
                          <a href="#"><i class="fab fa-twitter"></i></a>
                          <a href="#"><i class="fab fa-instagram"></i></a>
                          <a href="#"><i class="fab fa-whatsapp"></i></a>
                          <a href="#"><i class="fab fa-youtube"></i></a>
                        </div>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <aside class="sidebar">
                <div class="widget search">
                  <h5 class="widget-title">Search</h5>
                  <form class="search-form">
                    <input type="text" class="form-control" placeholder="Search Here..." />
                    <button type="submit"><i class="far fa-search"></i></button>
                  </form>
                </div>

                <div class="widget category" v-if="articleGroup" style="text-align: left">
                  <h5 class="widget-title">Danh mục</h5>
                  <div class="category-list">
                    <router-link :to="navBlogLink(m)" v-for="m in articleGroup" :key="m._id"><i
                        class="far fa-arrow-right"></i>{{ m.name
                        }}<span></span></router-link>
                  </div>
                </div>

                <div class="widget recent-post">
                  <h5 class="widget-title">Bài viết liên quan</h5>
                  <div class="recent-post-single" v-for="bl in blogsLQ" :key="bl._id">
                    <div class="recent-post-img">
                      <img :src="bl.avatar" alt="thumb" />
                    </div>
                    <div class="recent-post-bio">
                      <h6>
                        <router-link :to="blogLink(bl._id, bl.alias)">
                          {{ bl.name }}
                        </router-link>
                      </h6>
                      <span><i class="far fa-clock"></i>{{ timeString(bl.lastUpdate) }}</span>
                    </div>
                  </div>
                </div>

                <div class="widget social-share">
                  <h5 class="widget-title">Follow Us</h5>
                  <div class="social-share-link">
                    <a href="#"><i class="fab fa-facebook-f"></i></a>
                    <a href="#"><i class="fab fa-twitter"></i></a>
                    <a href="#"><i class="fab fa-dribbble"></i></a>
                    <a href="#"><i class="fab fa-whatsapp"></i></a>
                    <a href="#"><i class="fab fa-youtube"></i></a>
                  </div>
                </div>

                <!-- <div class="widget sidebar-tag">
                  <h5 class="widget-title">Popular Tags</h5>
                  <div class="tag-list">
                    <a href="#" v-for="ta in blogTag" :key="ta">{{ ta }}</a>
                  </div>
                </div> -->
              </aside>
            </div>
          </div>
        </div>
      </div>
    </main>
  </PublicView>
</template>
<style lang="less">
.article-content {
  text-align: left;
  font-size: 18px;

  ul {
    padding-left: 30px;

    li {
      list-style: initial;
    }
  }

  p {
    &:empty {
      min-height: 1.5em;
    }
  }
}

.ratio {
  &.ratio-16-9 {
    padding-top: 56.25% !important;
    position: relative;
  }

  .wrap {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
</style>
<script>
import PublicView from "@/components/PublicView.vue";

export default {
  data() {
    return {
      previewImg: "",
      material: null,
      color: null,
    };
  },
  methods: {
    timeString(time) {
      return new Date(time).toLocaleDateString();
    },
    navBlogLink(b) {
      return "/blogs/" + b.alias + "/" + b._id;
    },
    selectColor(c) {
      this.color = c.name;
    },
    selectMaterial(m) {
      this.material = m;
      if (this.color) {
        let colorCheck = this.material.colors.find((i) => i.name == this.color);
        if (!colorCheck) {
          this.color = null;
        }
      }
    },
    styleColor(c) {
      return "background: " + c;
    },
    version(year, pre = "") {
      let result = [];
      for (let i = 0; i < year.length; i++) {
        let text = year[i].year;
        let vers = [];
        for (let ver in year[i].versions) {
          vers.push(year[i].versions[ver].v);
        }
        if (vers.length > 0) {
          result.push(vers.map((i) => pre + i + " " + text).join(", "));
        } else {
          result.push(text);
        }
      }
      return result.length > 0 ? result.join(", ") : "";
    },
    blogLink(id, alias) {
      return "/blog/" + alias + "/" + id;
    },
    numberFormat(num) {
      return new Intl.NumberFormat("vi-VN", {
        style: "currency",
        currency: "VND",
      }).format(num);
    },
  },
  mounted() {
    console.log(this.blog);
    if (
      this.blog &&
      Array.isArray(this.blog.images) &&
      this.blog.images.length > 0
    ) {
      this.previewImg = this.blog.images[0];
    }
    console.log(window.FB);
    if (window.FB && this.$el.querySelector("#blog-comments")) {
      window.FB.XFBML.parse(
        this.$el.querySelector("#blog-comments").parentNode
      );
    }
  },
  components: {
    PublicView,
  },
  computed: {
    currentHref() {
      return window.location.href;
    },
    blogTag() {
      if (this.blog && this.blog.tag) {
        return this.blog.tag.split(",").map((i) => i.trim());
      } else {
        return [];
      }
    },
    articleGroup() {
      if (this.navData) {
        return this.navData.articleGroup;
      }
      return null;
    },
    navData() {
      return this.$store.getters.navData;
    },
    blogs() {
      let blogs = this.$store.getters.blogs;
      return blogs;
    },
    blogsLQ() {
      if (this.blogs && this.blog) {
        let allWithPoint = this.blogs
          .filter((i) => i._id != this.$route.params.id)
          .map((n) => {
            let point = 0;
            if (typeof n.tag == "string") {
              let tag = n.tag.split(",").map((i) => i.trim().toLowerCase());
              let blogTag = this.blogTag;
              for (let y = 0; y < blogTag.length; y++) {
                for (let x = 0; x < tag.length; x++) {
                  if (tag[x].indexOf(blogTag[y].toLowerCase()) != -1) {
                    point++;
                  }
                }
              }
            }
            return {
              point,
              blog: n,
            };
          });
        allWithPoint.sort(function (a, b) {
          return b.point - a.point;
        });
        allWithPoint = allWithPoint
          .filter((i) => i.point > 0)
          .filter((i, k) => k < 5)
          .map((i) => i.blog);
        return allWithPoint;
      } else {
        return [];
      }
    },
    blog() {
      let blog = this.$store.getters.blog(this.$route.params.id);
      if (blog) {
        document.querySelector("title").innerText =
          "Alphatech.vn - " + blog.seoData.title;
      }
      return blog;
    },
  },
  watch: {
    blog(v) {
      if (Array.isArray(v.images) && v.images.length > 0) {
        this.previewImg = v.images[0];
        if (window.FB && this.$el.querySelector("#blog-comments")) {
          window.FB.XFBML.parse(
            this.$el.querySelector("#blog-comments").parentNode
          );
        }
      }
    },
  },
};
</script>